import React from "react";
import AToggleButtonGroup from "../../../../../../../components/AToggleButtonGroup/AToggleButtonGroup";
import { selectedChargesFilter } from "../../utils";
import { useGetCollectPaymentContext } from "../../context";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";
import DownloadChargesData from "../downloadChargesData";

const SelectChargesCardHeader = () => {
  const { setFilterHandler, selectedCharges } = useGetCollectPaymentContext();

  const isApplyHandler = () => {
    const { OTHER_CHARGES, REGULAR_CHARGES } = selectedCharges;
    if (OTHER_CHARGES?.length > 0 || REGULAR_CHARGES?.length > 0) return false;
    return true;
  };

  const applyFilterHandler = (value) => {
    if (!isApplyHandler()) {
      return;
    }
    if (value) setFilterHandler(value);
  };
  return (
    <div className="d-flex justify-content-between mb-2">
      <div className="heading-3 text-bold label-color">
        Select payment charges
      </div>

      <div className="d-flex">
        
        <AToggleButtonGroup
          changeHandler={(value) => applyFilterHandler(value)}
          options={selectedChargesFilter}
          defaultSelected="all"
          isApplyHandler={isApplyHandler()}
          alertHandler={() => {
            failureToast("Filters cannot be applied once charges are selected.");
          }}
        />

        <DownloadChargesData/>

      </div>
    </div>
  );
};

export default SelectChargesCardHeader;
